<template>
  <WidgetCard :title="heading" :subtitle="subHeading">
    <v-data-table
      hide-default-footer
      class="mt-n2 clickable"
      :headers="_headers"
      :items="items"
      :items-per-page="-1"
      item-key="id"
      @click:row="showApplication"
    >
      <template slot="item.id" slot-scope="props" v-if="companyId && get(props, 'item.id', null)">
        <div style="width: 115px">
          {{ get(props, 'item.id', null) }}
        </div>
      </template>
      <!-- Application name header -->
      <template slot="item.name" slot-scope="props">
        <div style="width: 140px">
          {{ props.item.company.name }}
          {{ props.item.name }} ({{ props.item.personalNumber | formatSecretPnr }})
        </div></template
      >
      <template slot="item.company.contracttype" slot-scope="props">
        <div style="width: 115px">
          {{ get(props, 'item.company.contracttype.name', '') }}
        </div>
      </template>
      <template slot="item.profession" slot-scope="props">
        <div style="width: 170px">
          {{ props.item.profession }}
        </div>
      </template>
      <template slot="item.region" slot-scope="props">
        <div style="width: 170px">
          {{ props.item.region }}
        </div>
      </template>
      <template slot="item.state" slot-scope="props">
        <div style="width: 170px">
          {{ applicationStateName(props.item) }}
        </div>
      </template>
      <template slot="item.issuedOn" slot-scope="props">
        <span class="widget-normal" style="width: 100px">{{ props.item.issuedOn | date }}</span>
      </template>
      <template slot="item.notes" slot-scope="props">
        <div style="width: 50px">
          <v-icon v-if="props.item.notes && props.item.notes.length">$sl-message</v-icon>
        </div>
      </template>

    </v-data-table>
  </WidgetCard>
</template>


<script>
import API from '@/services/api'
import get from 'lodash/get'
import {mapGetters} from 'vuex'
import WidgetCard from '@/components/widgets/WidgetCard.vue'
// @group Widgets
// ApplicationApprentice component
export default {

  name: 'Applications',

  components: {
    WidgetCard
  },
  
  props: {
    companyId: {
      type: Number,
      default: null
    },
    heading: {
      type: String,
      default: 'Inkomna lärlingsanmälningar'
    },
    subHeading: {
      type: String,
      default: 'Att granska, godkänna eller bekräfta'
    },
    stateIds: {
      type: Array,
      default: () => ([])
    }
  },

  data: () => ({
    items: [],
    stateId: [],
    headers: [
      {text: 'Avser', value: 'name', width: '150'},
      {text: 'Avtalstillhörighet', value: 'contractType', width: '129'},
      {text: 'Yrke', value: 'profession', width: '180', sortable: false},
      {text: 'Region', value: 'region', width: '180', sortable: false},
      {text: 'Status/Agerat', value: 'state', width: '180', sortable: false},
      {text: 'Datum', value: 'issuedOn', sortable: false, width: '100'},
      {text: 'Ant.', value: 'notes', sortable: false, width: '50'}
    ]
  }),

  watch: {
    handledCasesAreVisible: {
      handler(val) {
        if ( val ) {
          this.getApplications().then(() => this.filterMyCases())
        } else {
          this.getApplications()
        }
      }
    }
  },

  computed: {
    ...mapGetters('currentuser', ['currentUser', 'handledCasesAreVisible']),
    ...mapGetters('basic', [
      'basicApplicationStates',
      'basicRegions',
      'getApprovedApplications',
      'confirmedAndApprovedByCompany',
      'getProfessionNameById',
      'getOrderedApplication',
    ]),

    _headers() {
      if ( this.companyId ) {
        const newHeader = { text: 'Nr', value: 'id', width: '150' }
        return [newHeader].concat(this.headers)
      }

      return this.headers
    }
  },

  created() {
    this.getApplications().then(() => this.handledCasesAreVisible && this.filterMyCases())
  },

  methods: {
    get,

    /* init: debounce(function () {
        this.getApplications()
      }, 200), */
    showApplication(item) {
      this.$router.push({name: 'Application', params: {id: item.id}}).catch(() => {})
    },
    /**
     * @vuese
     * Used to fetch the list of applications
     * @arg The  argument is a object representing search criteries
     */
    getApplications() {
      this.stateId = this.confirmedAndApprovedByCompany.concat(this.getOrderedApplication)

      if (this.stateId) {
        
        let advSearch =  {stateId: this.stateId}

        if ( this.handledCasesAreVisible ) {
          advSearch.stateId = [7,8,9,11]
        }

        if(get(this.currentUser, "userrole.isRegionary", false) == true) {
          advSearch.regionId = get(this.currentUser, 'userRegions', []).map(region => region.regionId)
        }
        
        if (this.companyId) {
          //- Filter applications by `companyId`
          advSearch = { stateId: this.stateIds, companyId: this.companyId }
        }

        return API.listApplications({
          startAt: 0,
          sortBy: 'lastName',
          sortDesc: 'ASC',
          advSearch: advSearch,
          pageSize: 500,
          transferOldProfession: true,
          handledCasesAreVisible: this.handledCasesAreVisible
        })
          .then(response => {
            this.items = []
            let company = ''
            response.data.rows.forEach(ap => {
              return this.items.push({
                personalNumber: ap.personalNumber ? ap.personalNumber : '',
                name: ap.firstName && ap.lastName ? this.$options.filters.fullName(ap) : '',
                company: company,
                profession: ap.professionId ? this.getProfessionNameById(ap.professionId) : '',
                contractType: ap?.company?.contracttype?.name ?? '',
                region: ap.region ? ap.region.name : '',
                issuedOn: ap.createdAt ? ap.createdAt : '',
                state: ap.state && ap.state.name ? ap.state.name : '',
                id: ap.id ? ap.id : '',
                notes: ap.notes,
                transferOldProfession: get(ap, 'transferOldProfession', false),
                transferApprovedById: get(ap, 'transferApprovedById', null),
                orderedById: ap.orderedBy?.id || null,
                approvedById: ap.approvedBy?.id || null,
                orderedBy: get(ap, 'orderedBy', null),
                transferIssuedBy: get(ap, 'transferIssuedById', null)
              })
            })
          })
          .catch(error => {
            console.log('There was an error:', error)
          })
      }
    },

    applicationStateName(item = {}) {
      let text = item.state

      if ( item?.transferOldProfession ) {
        text = '(Förflyttning) Bekräftad och godkänd av företag'
        
        if ( item?.transferIssuedBy )
          text = `(Förflyttning) ${ item.transferIssuedBy?.firstName } ${ item.transferIssuedBy?.lastName }`
      } 

      if ( item?.orderedBy )
        text = `${ item.orderedBy?.firstName } ${ item.orderedBy?.lastName }`
      
      return text
    },
    
    filterMyCases() {
      return this.items = this.items.filter(i => {
        if ( !i.approvedById && !i.orderedById ) return false
        return [i.approvedById, i.orderedById].includes(this.currentUser?.id)
      })
    }
  }
}
</script>

<style scoped>
</style>
